import { render, staticRenderFns } from "./CompassNoticeBar.vue?vue&type=template&id=d6d0f472&scoped=true"
import script from "./CompassNoticeBar.vue?vue&type=script&lang=js"
export * from "./CompassNoticeBar.vue?vue&type=script&lang=js"
import style0 from "./CompassNoticeBar.vue?vue&type=style&index=0&id=d6d0f472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d0f472",
  null
  
)

export default component.exports